import { HTMLAttributes, ReactNode } from 'react';

export interface DashboardContextProps {
  currentView?: DashboardPages;
}

export enum DashboardPages {
  Home = '',
  Commerciaux = 'commerciaux',
  Historique = 'historique',
  Receipts = 'receipts',
  Subscriptions = 'subscriptions',
  Prospect = 'prospects',
  Prospection = 'prospection',
  Companies = 'companies',
  Map = 'map',
  Consultations = 'consultations',
  InProgressConsultations = 'consultations_in_progress',
  ClosedConsultations = 'consultations_closed',
  Facturation = 'facturation',
  Stats = 'stats',
  Results = 'results',
  Profile = 'profile',
}

export interface DashboardLayoutProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  isLoading?: boolean;
}
